import { modals } from './modals';
import { formValidation } from './form-validation';
import { rules as formValidationRules } from './form-validation.rules';

export const footer = {
    init: () => {
        console.debug("footer.js: init");

        footer.expandFooterMobileNavigation();

        const signupnewsletterfooterform = document.getElementById("signupnewsletterfooter");
        formValidation.injectDataTag(true, formValidationRules.email, signupnewsletterfooterform.querySelector('#signupnewsletteremail'), prestashop.language.iso_code);
        formValidation.addListeners(signupnewsletterfooterform,
            (event) => {
                event.preventDefault();
                footer.submitNewsletterSignup(signupnewsletterfooterform);
            }
        );

    },
    submitNewsletterSignup: (form) => {
        const formData = new FormData(form);

        const url = form.action
        const fetchOptions = {
            method: "POST",
            body: formData,
        };
        fetch(url, fetchOptions)
            .then(res => res.json())
            .then(json => {
                modals.ol.html(`
                <div class="modal-box" id="footernewslettersignupmodal">
                    <svg style='cursor:pointer;float: right;' onclick="$('.page-overlay').trigger('click')" class="dpj-icon dpj-icon-close" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" xml:space="preserve"><g transform="translate(18877.419 20762.419)"><line class="st0" x1="-18859.2" y1="-20756.7" x2="-18871.7" y2="-20744.2"></line><line class="st0" x1="-18871.7" y1="-20756.7" x2="-18859.2" y2="-20744.2"></line></g></svg>
                    <div style="height: 300px; font-size: 22px; display: flex; align-items: center; align-content: center; justify-content: center; ">
                        <div>${$("#signupnewsletterfooterokmessage").text()}</div>
                    </div>
                </div>`);
                $("#footernewslettersignupmodal").show();
                modals.togglePageOverlay();
            })
            .catch(err => alert(err))
    },
    expandFooterMobileNavigation: () => {

        $(".footer-section-closeable-mobile").each(function (index) {
            $(this).parent().find("h4").html('<div class="footer-section-arrow-mobile"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" /> </svg> </div>' + $(this).parent().find("h4").html());
        });


        $(".footer-section-closeable-mobile").parent().find("h4").on("click", function (e) {
            if ($(this).parent().find(".footer-section-closeable-mobile").hasClass("footer-section-closeable-mobile-open")) {
                $(this).parent().find(".footer-section-closeable-mobile").removeClass("footer-section-closeable-mobile-open");
                $(this).parent().find(".footer-section-arrow-mobile").css("transform", "rotate(90deg) rotateY(0deg)");
            } else {
                $(this).parent().find(".footer-section-closeable-mobile").addClass("footer-section-closeable-mobile-open");
                $(this).parent().find(".footer-section-arrow-mobile").css("transform", "rotate(90deg) rotateY(180deg)");
            }
        });
        
        // Open first block
        $(".footer-section-closeable-mobile").first().parent().find("h4").trigger("click");
    }
}
